import Text from "@afa-shared/afa-components/dist/Text";
import { StandardLink } from "@components/Link/StandardLink";
import Message from "@components/Message/Message";
import React, { ReactNode } from "react";

import formStyles from "../FormStyles/forms.module.css";

interface IFormSuccessFeedback {
  messageHeading?: string;
  messageChildren?: ReactNode;
  messageLink?: ReactNode;
  messagePreset?: string;
}

const getHeading = (messageHeading, messagePreset): string => {
  if (messagePreset) return "Tack för ditt meddelande!";

  return messageHeading;
};

const getText = (messageChildren, messagePreset): React.ReactNode | string => {
  switch (messagePreset) {
    case "defaultContactForm":
      return (
        <>
          <Text
            variant="paragraph"
            children={
              "Du får svar inom två vardagar. Om du har begärt en kopia av meddelandet till din e-postadress kontrollera att den inte hamnat i din skräppost."
            }
          />
          <Text
            variant="paragraph"
            children={
              "För att skydda dina personuppgifter kan vi inte gå in i detalj på ditt ärende när vi svarar dig via e-post. När vi har avslutat ärendet raderar vi alla e-postmeddelanden."
            }
          />
        </>
      );
    case "eServicesContactForm":
      return (
        <Text
          variant="paragraph"
          children={
            "Du får svar inom två vardagar. Om du har begärt en kopia av meddelandet till din e-postadress kontrollera att den inte hamnat i din skräppost."
          }
        />
      );
    default:
      return messageChildren;
  }
};

const getLink = (messageLink, messagePreset): React.ReactNode | string => {
  const personuppgifterPath = "/personuppgifter";
  if (messagePreset)
    return <StandardLink href={personuppgifterPath} text={"Så behandlar vi personuppgifter"} />;

  return messageLink;
};

const FormSuccessFeedback = ({
  messageHeading,
  messageChildren,
  messageLink,
  messagePreset,
}: IFormSuccessFeedback) => {
  const heading = getHeading(messageHeading, messagePreset);
  const text = getText(messageChildren, messagePreset);
  const link = getLink(messageLink, messagePreset);

  return (
    <div className={formStyles.formSuccessFeedback}>
      <Message
        heading={heading}
        headingVariant={"h2"}
        type={"success"}
        children={text}
        linkType={link}
      />
    </div>
  );
};

export default FormSuccessFeedback;
